import IconCheckCircle from "../icons/IconCheckCircle";
import clsx from "clsx";
import styles from "./Checklist.module.css";

interface ChecklistProps {
  className?: string;
  color?: "neutral" | "primary" | "success";
  items: {
    label: string;
    checked: boolean;
  }[];
}

export default function Checklist({ color = "neutral", items, className }: ChecklistProps) {
  return (
    <ul className={clsx(className, styles.root)} data-color={color}>
      {items.map((item, i) => (
        <li className={styles.item} key={`${item.label}-${i}`} data-checked={item.checked}>
          <IconCheckCircle currentColor={true} />
          <span className={"small-text"}>{item.label}</span>
        </li>
      ))}
    </ul>
  );
}
